import './VersionInfo.scss'
export default function VersionInfo() {
  return (
    <h4 className="version-info">
      v1.0.{process.env.REACT_APP_BUILD_ID} {process.env.REACT_APP_ENV}
    </h4>
  )
}
